export default "__VITE_ASSET__2d64deb3__"